/**
 * @generated SignedSource<<4810be70391ae04450241bd5b5db7cd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery$variables = {
  guid: string;
};
export type useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery$data = {
  readonly event: {
    readonly stream: {
      readonly schedulingMeetingAssistantAutomationIsActive: boolean;
    } | null;
  } | null;
};
export type useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery = {
  response: useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery$data;
  variables: useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schedulingMeetingAssistantAutomationIsActive",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery",
    "selections": [
      {
        "alias": "event",
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "784cd1bb577999b6d00d7d2d4fefbdab",
    "id": null,
    "metadata": {},
    "name": "useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery",
    "operationKind": "query",
    "text": "query useSaveEventMutationRefetchMeetingAssistantAutomationValueQuery(\n  $guid: String!\n) {\n  event: eventByGuid(guid: $guid) {\n    stream {\n      schedulingMeetingAssistantAutomationIsActive\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6b07066c5dc2eeb8b2c616b81677c939";

export default node;
